import request from '@/router/axios'

export function getRewardRuleList () {
  return request({
    url: '/admin/reward-rule/list',
    method: 'get'
  })
}

export function enableRule (id) {
  return request({
    url: '/admin/reward-rule/status/' + id,
    method: 'post',
    params: {
        isEnabled : true
    }
  })
}

export function disableRule (id) {
  return request({
    url: '/admin/reward-rule/status/' + id,
    method: 'post',
    params: {
        isEnabled : false
    }
  })
}

export function modifyRule (obj) {
  return request({
    url: '/admin/reward-rule/modify',
    method: 'post',
    data: obj
  })
}